import { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
//prime React
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Tooltip } from "primereact/tooltip";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { confirmDialog } from "primereact/confirmdialog";
//components
import Input from "../../../../components/input/Input";
import Select from "../../../../components/input/Select";
import NumberInput from "../../../../components/input/NumberInput";
//services
import { getAnnulment } from "../../../../services/Enterprise/getAnnulment";
import { postAnnulment } from "../../../../services/Enterprise/postAnnulment";
import { deleteAnnulment } from "../../../../services/Enterprise/deleteAnnulment";
//utils
import { queryClient } from "../../../../utils/queryClient";
import { useAppContext } from "../../../../context/AppContext";

export default function Cancellation(id) {
  const { permissions } = useAppContext();
  const [loading, setLoading] = useState(false);

  const columns = [
    { field: "desc", header: "Descrição do Custo" },
    { field: "percentage", header: "% Cobrado" },
    { field: "impact_costs", header: "Impacto do Custo" },
  ];

  const impact = [
    { value: 0, label: "Valor do Contrato" },
    { value: 1, label: "Valor Pago" },
  ];

  const form = useForm();
  const errors = form.formState.errors;

  const {
    data: annulmentQuery,
    isLoading: isLoadingAnnulment,
    refetch,
  } = useQuery({
    queryKey: [`annulment${id.id}`],
    queryFn: () => getAnnulment(id.id),
    enabled: !!permissions?.includes("56")
  });

//  console.log(annulmentQuery);

  const annulment = annulmentQuery
    ? annulmentQuery.map((i) => {
        if (i.impact_costs === 0) {
          return { ...i, impact_costs: "Valor do contrato" };
        } else if (i.impact_costs === 1) {
          return { ...i, impact_costs: "Valor Pago" };
        } else {
          return i;
        }
      })
    : []; // if ternário para esperar a consulta do useQuery

  const { mutateAsync: postAnnulmentFn } = useMutation({
    mutationFn: postAnnulment,
    onSuccess(res, variables) {
      queryClient.setQueryData([`annulment${id.id}`], (data) => {
        delete variables.enterprise_id;
        return [...data, { ...variables, id: res.data.id }];
      });
    },
  });

  const { mutateAsync: deleteAnnulmentFn } = useMutation({
    mutationFn: deleteAnnulment,
    onSuccess(_, variables) {
      queryClient.setQueryData([`annulment${id.id}`], (data) => {
        const updatedClientFiles = data.filter((item) => item.id !== variables);
        return updatedClientFiles;
      });
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      var idInt = parseInt(id.id);
      data.enterprise_id = idInt;
      await postAnnulmentFn(data);
      toast.update(notification, {
        render: "Distrato cadastrado com sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (e) {
      toast.error(`Não Possível Cadastrar o Distrato!`);
    }
    form.reset();
    refetch();
    setLoading(false);
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  const annulmentDelete = async (id) => {
    try {
      const notification = toast.loading("Por favor aguarde...");
      await deleteAnnulmentFn(id);
      toast.update(notification, {
        render: "Distrato Deletado com sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      refetch();
    } catch (e) {
      toast.error(`Não Possível Deletar o Distrato!`);
    }
  };

  const removeOption = (e, rowData) => {
    e.preventDefault();
    confirmDialog({
      message: "Deseja fazer a exclusão?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => annulmentDelete(rowData.id),
    });
  };

  return (
    <>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-12">
            <h4>
              {" "}
              Informe os dados sobre Distrato/Cancelamento da Venda
              <Tooltip target=".custom-target-icon" />
              <i
                className="custom-target-icon px-2 pi 
                    pi-info-circle p-text-secondary"
                data-pr-tooltip="Configure os cálculos para abater na devolução do valor do contrato. Ex: Corretagem 5% do valor do contrato; Taxas de boleto 1% do valor pago."
                style={{ cursor: "pointer" }}
              ></i>
            </h4>

            <Input
              name="desc"
              control={form.control}
              label="Descrição do Motivo do Custo"
              errors={errors}
            />
          </div>
          <div className="col-md-6 mt-4">
            <h4>
              {" "}
              Cobrado
              <Tooltip target=".custom-target-icon" />
              <i
                className="custom-target-icon px-2 pi 
                    pi-info-circle p-text-secondary"
                data-pr-tooltip="indique aqui a porcentagem que será cobrada no distrato"
                style={{ cursor: "pointer" }}
              ></i>{" "}
            </h4>

            <NumberInput
              suffix="%"
              placeholder="0%"
              max={100}
              minFractionDigits={2}
              name="percentage"
              control={form.control}
              label="Fundo de Reserva"
              getFormErrorMessage={getFormErrorMessage}
            />
          </div>
          <div className="col-md-6 mt-4">
            <h4>
              {" "}
              Impacto do Custo
              <Tooltip target=".custom-target-icon" />
              <i
                className="custom-target-icon mx-2 pi 
                    pi-info-circle p-text-secondary"
                data-pr-tooltip="indique aqui sobre qual valor será cobrado a porcentagem de distrato"
                style={{ cursor: "pointer" }}
              ></i>
            </h4>
            <Select
              name="impact_costs"
              errors={errors}
              label="Escolha"
              options={impact}
              control={form.control}
            />
          </div>
          <hr className="my-4" />
          <div className="px-2 pb-3">
            {isLoadingAnnulment ? (
              <Skeleton width="100%" height="200px" />
            ) : (
              <DataTable
                rows={5}
                paginator
                stripedRows
                showGridlines
                sortMode="multiple"
                selectionMode="single"
                rowsPerPageOptions={[5, 25, 100]}
                value={annulment}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
              >
                {columns.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                  />
                ))}
                <Column
                  header="Ações"
                  body={(rowData) => (
                    <div className="text-center">
                      <button
                        className="btn btn-danger btn-btn-sm"
                        onClick={(e) => removeOption(e, rowData)}
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </button>
                    </div>
                  )}
                />
              </DataTable>
            )}
          </div>
          <hr className="my-4" />
          <div className="col-md-12 text-end">
            <Button
              rounded
              type="submit"
              loading={loading}
              iconPos="right"
              label="Finalizar"
              icon="fa-solid fa-circle-chevron-right"
              className="p-inputtext-sm m-auto"
            />
          </div>
        </div>
      </form>
    </>
  );
}
